/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RiskFlag
 */
export interface RiskFlag {
    /**
     * 
     * @type {string}
     * @memberof RiskFlag
     */
    initiativeId?: string;
    /**
     * 
     * @type {string}
     * @memberof RiskFlag
     */
    initiativeName?: string;
    /**
     * 
     * @type {string}
     * @memberof RiskFlag
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof RiskFlag
     */
    severity?: string;
    /**
     * 
     * @type {string}
     * @memberof RiskFlag
     */
    message?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof RiskFlag
     */
    details?: { [key: string]: string; };
}

/**
 * Check if a given object implements the RiskFlag interface.
 */
export function instanceOfRiskFlag(value: object): value is RiskFlag {
    return true;
}

export function RiskFlagFromJSON(json: any): RiskFlag {
    return RiskFlagFromJSONTyped(json, false);
}

export function RiskFlagFromJSONTyped(json: any, ignoreDiscriminator: boolean): RiskFlag {
    if (json == null) {
        return json;
    }
    return {
        
        'initiativeId': json['initiativeId'] == null ? undefined : json['initiativeId'],
        'initiativeName': json['initiativeName'] == null ? undefined : json['initiativeName'],
        'type': json['type'] == null ? undefined : json['type'],
        'severity': json['severity'] == null ? undefined : json['severity'],
        'message': json['message'] == null ? undefined : json['message'],
        'details': json['details'] == null ? undefined : json['details'],
    };
}

export function RiskFlagToJSON(json: any): RiskFlag {
    return RiskFlagToJSONTyped(json, false);
}

export function RiskFlagToJSONTyped(value?: RiskFlag | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'initiativeId': value['initiativeId'],
        'initiativeName': value['initiativeName'],
        'type': value['type'],
        'severity': value['severity'],
        'message': value['message'],
        'details': value['details'],
    };
}

